// Approval Engine API endpoints
export const APPROVAL_ENGINE_ENDPOINTS = {
  BASE: "/v1.0/dispute/approvalengines",
  CREATE: "/v1.0/dispute/approvalengines",
  UPDATE: (id) => `/v1.0/dispute/approvalengines/${id}`,
  DEACTIVATE: (id) => `/v1.0/dispute/approvalengines/${id}/deactivate`,
  ACTIVATE: (id) => `/v1.0/dispute/approvalengines/${id}/activate`,
  GET_BY_ID: (id) => `/v1.0/dispute/approvalengines?id=${id}`,
  LIST: "/v1.0/dispute/approvalengines",
};
